var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FootSwiper"},[_c('van-swipe',{attrs:{"show-indicators":false,"autoplay":3000}},_vm._l((_vm.swipeList),function(item){return _c('van-swipe-item',{key:item.id},[_c('img',{attrs:{"src":item.src,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }